import React from "react";
import starIcon from "../../media/guestpage/starIcon.svg";

const SectionTitle = ({ children, className = "", id }) => {
    return (
        <div className={`guest-section-title ${className}`.trim()} id={id}>
            <img
                className="guest-section-title__icon"
                src={starIcon}
                alt=""
                aria-hidden="true"
            />
            <div className="guest-section-title__text">{children}</div>
        </div>
    );
};

export default SectionTitle;
